document.addEventListener("DOMContentLoaded", () => {
    if (!customElements.get("index-image-swiper")) {
        class IndexImageSwiper extends HTMLElement {
            constructor() {
                super();
                this.container = this.querySelector(".index-image-swiper");
                this.swiper_obj = this.querySelector(".swiper");
                this.swiper = null;
            }
            connectedCallback() {
                this.detectObserver();
            }
            detectObserver() {
                let height = window.innerHeight / 2;
                if (this.container) {
                    const resizeObserver = new IntersectionObserver(
                        ([entry]) => {
                            if (entry.isIntersecting) {
                                this.initSwiper();
                                resizeObserver.disconnect();
                            }
                        },
                        { threshold: 0, rootMargin: `${height}px 0px 0px 0px` }
                    );
                    resizeObserver.observe(this.container);
                }
            }
            initSwiper() {
                if (!this.swiper_obj) return;
                const pagination = this.querySelector(".swiper-pagination");
                const swiper_auto = this.getAttribute("data-swiper_auto") == 'true' ? true : false
                const swiper_auto_time = this.getAttribute("data-swiper_auto_time") * 1
                const loop = this.getAttribute("data-swiper_loop") == 'true' ? true : false
                let autoplay = false
                if (swiper_auto) {
                    autoplay = {
                        delay: swiper_auto_time,
                        stopOnLastSlide: false,
                        disableOnInteraction: true,
                    }
                }

                const slidesPerView = 1.25
                const breakpoints = {
                    1024: {
                        spaceBetween: 10,
                        slidesPerView: 3,
                    },
                }

                // Swiper loop mode needs enough real slides. When there are only a few
                // (e.g. 4 slides while desktop shows 3 at once), sliding past the last
                // slide leaves empty space at the edge / the loop breaks after resize.
                // Duplicate the slides until there are at least 2x the largest
                // slidesPerView, so the loop always has enough slides to wrap around.
                const maxSlidesPerView = Math.max(
                    slidesPerView,
                    ...Object.values(breakpoints).map((bp) => bp.slidesPerView)
                )
                const wrapper = this.swiper_obj.querySelector(".swiper-wrapper")
                // The template can pre-render duplicated slides
                // (data-swiper_loop_copies, see index-image-swiper.liquid).
                const loopCopies = parseInt(this.getAttribute("data-swiper_loop_copies") || "", 10)
                const templateCopies =
                    Number.isFinite(loopCopies) && loopCopies > 0 ? loopCopies : 1
                let duplicated = false
                let uniqueSlides = 0
                if (loop && wrapper) {
                    const slides = Array.from(wrapper.children)
                    if (templateCopies > 1) {
                        // Slides are already duplicated in the template markup.
                        duplicated = true
                        uniqueSlides = Math.max(1, Math.round(slides.length / templateCopies))
                    } else {
                        // Fallback: duplicate the slides here so the loop always has
                        // enough real slides to wrap around.
                        uniqueSlides = slides.length
                        const minLoopSlides = Math.ceil(maxSlidesPerView) * 2
                        const copies = Math.max(1, Math.ceil(minLoopSlides / uniqueSlides))
                        duplicated = copies > 1
                        for (let c = 1; c < copies; c += 1) {
                            slides.forEach((slide) => {
                                const clone = slide.cloneNode(true)
                                clone.removeAttribute("id")
                                clone.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"))
                                wrapper.appendChild(clone)
                            })
                        }
                    }
                }

                const paginationOptions = { el: pagination, clickable: true }
                if (duplicated) {
                    // The duplicated slides are only for a seamless loop, so let
                    // Swiper skip the pagination entirely; setupUniquePagination()
                    // renders one bullet per real slide below.
                    paginationOptions.el = null
                }

                const options = {
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: slidesPerView,
                    simulateTouch: true,
                    spaceBetween: 20,
                    autoplay: autoplay,
                    loop: loop,
                    pagination: paginationOptions,
                    breakpoints: breakpoints,
                }
                if (loop) {
                    // Clone extra slides around the loop edges so the area on both
                    // sides of the active slide stays filled while wrapping.
                    options.loopAdditionalSlides = Math.max(0, Math.ceil(maxSlidesPerView) - 1)
                }

                this.swiper = new Swiper(this.swiper_obj, options)

                if (duplicated && pagination && uniqueSlides > 0) {
                    this.setupUniquePagination(pagination, uniqueSlides)
                }
            }
            setupUniquePagination(pagination, uniqueSlides) {
                const updateActive = () => {
                    const activeIndex = this.swiper.realIndex % uniqueSlides
                    pagination.querySelectorAll(".swiper-pagination-bullet").forEach((bullet, i) => {
                        bullet.classList.toggle("swiper-pagination-bullet-active", i === activeIndex)
                    })
                }
                // Render exactly one bullet per configured slide (uniqueSlides),
                // regardless of how many times slides were duplicated for the loop.
                pagination.innerHTML = ""
                for (let i = 0; i < uniqueSlides; i += 1) {
                    const bullet = document.createElement("span")
                    bullet.className = "swiper-pagination-bullet"
                    bullet.addEventListener("click", () => {
                        this.swiper.slideToLoop(i)
                    })
                    pagination.appendChild(bullet)
                }
                this.swiper.on("slideChange", updateActive)
                updateActive()
            }
        }
        customElements.define("index-image-swiper", IndexImageSwiper);
    }
});